import { defineStore } from 'pinia';
import ShippingFeesRule from '../entities/shipping-fees-rule';

export const useShippingFeesLocationsStore = defineStore('shippingFeesLocationsStore', {
	state: () => ({
		loading: false,
		rules: [],
		originalRules: [],
		defaultRule: undefined,
		originalDefaultRule: undefined,
	}),
	actions: {
		async fetchRules() {
			this.loading = true;
			try {
				const { data, defaultRule } = await ShippingFeesRule.fetchRules({
					per_page: 1000,
					sort_direction: 'asc',
				});
				this.rules = data;
                this.rules.unshift(defaultRule);

				this.originalRules = this.rules.map(
					(rule) => new ShippingFeesRule(JSON.parse(JSON.stringify(rule))),
				);

			} finally {
				this.loading = false;
			}
		},
		addNewRule() {
			const rule = new ShippingFeesRule({
				id: `rule-${Math.random()}`,
				ranges: [
					{
						id: `range-${Math.random()}`,
						isLocal: true,
						from: 0,
						to: '',
						price: '',
					},
				],
				isLocal: true,
			});
			this.rules.push(rule);
		},
		async removeRule(idx) {
			const rule = this.rules[idx];
			await rule.remove();
			this.rules.splice(idx, 1);
		},
	},
});
